const { DEV } = require("./constants/defaults");
const { PROD } = require("./constants/defaults");
const environment_dev = DEV; // Set DEV
const environment_prod = PROD; // Set PROD

export const environment = (process.env.REACT_APP_STAGE === 'prod')?environment_prod:environment_dev

//export const environment = environment_prod